import React from "react";
import Card from "../../shared/components/UIElements/Card";
import Input from "../../shared/components/FormElements/Input";
import Button from "../../shared/components/FormElements/Button";
import { useForm } from "../../shared/hooks/form-hook";
import {
  VALIDATOR_EMAIL,
  VALIDATOR_MINLENGTH,
  VALIDATOR_REQUIRE,
  VALIDATOR_PHONENUMBER,
} from "../../shared/Util/validators";

const PRACTICE_EMAIL = "monumentdental@hotmail.com";

const ContactUs = () => {
  const [formState, inputHandler] = useForm(
    {
      name: { value: "", isValid: false },
      email: { value: "", isValid: false },
      phoneNumber: { value: "", isValid: false },
      message: { value: "", isValid: false },
    },
    false
  );

  // No backend/email service is wired up, so we compose a pre-drafted email
  // and hand it off to the visitor's own mail client.
  const contactSubmitHandler = (event) => {
    event.preventDefault();
    const { name, email, phoneNumber, message } = formState.inputs;
    const subject = `Website inquiry from ${name.value}`;
    const body =
      `Name: ${name.value}\n` +
      `Email: ${email.value}\n` +
      `Phone: ${phoneNumber.value}\n\n` +
      `${message.value}`;
    window.location.href = `mailto:${PRACTICE_EMAIL}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
  };

  return (
    <Card className="contactUsCard">
      <h2>Send Us a Message</h2>
      <hr />
      <p className="contactUsCard__note">
        Fill out the form below and your email app will open with your message
        ready to send to our team.
      </p>
      <form onSubmit={contactSubmitHandler}>
        <Input
          element="input"
          id="name"
          type="text"
          label="Name"
          validators={[VALIDATOR_REQUIRE()]}
          errorText="Please enter a name."
          onInput={inputHandler}
        />
        <Input
          element="input"
          id="email"
          type="email"
          label="E-Mail"
          validators={[VALIDATOR_EMAIL()]}
          errorText="Please enter a valid email address."
          onInput={inputHandler}
        />
        <Input
          element="input"
          id="phoneNumber"
          type="tel"
          label="Telephone"
          validators={[VALIDATOR_PHONENUMBER()]}
          errorText="Please enter a valid phone number."
          onInput={inputHandler}
        />
        <Input
          element="textarea"
          id="message"
          label="Message"
          validators={[VALIDATOR_MINLENGTH(10)]}
          errorText="Please enter a message of at least 10 characters."
          onInput={inputHandler}
        />
        <Button type="submit" disabled={!formState.isValid}>
          Compose Email
        </Button>
      </form>
    </Card>
  );
};

export default ContactUs;
